import React, { useState, useEffect,useRef, useMemo } from 'react'
import $ from 'jquery';
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from '../firebaseConfig'

import '../js/common.js'

const Introduction = () => {

    const historyCollectionRef = useMemo(() => {
        return collection(db, "history");
    }, []);
    const [historyData, setHistoryData] = useState();
    const [currentMap, setCurrentMap] = useState(null);
    const mapInitialized = useRef(false);
    
    useEffect(() => {
        const getHistory = async () => {
            const q = query(historyCollectionRef, orderBy("title", "desc"))
            const data = await getDocs(q);
            setHistoryData(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
        }
        getHistory();
    }, [historyCollectionRef])

    useEffect(() => {
        if (mapInitialized.current) return;
        
        try {
            if(currentMap) return;
            // 국토교통부 map 셋팅
            let mapdiv = document.getElementById('map1');
            
            // 좌표 전환 : latlng방식이 아닌 "EPSG:5179"을 사용하므로 변환이 필요하다.
            const lng = 126.902207;
            const lat = 37.522891;
            const toCRS = 'EPSG:5179';
            // openlayers의 좌표 변환 함수를 사용하여 변환
            const center = window.ol.proj.fromLonLat([lng, lat],toCRS);
            
            // 기존 지도 사이즈로 셋팅
            mapdiv.style.width = '100%';
            mapdiv.style.height = '760px';
            // 지도 초기화
            const map = new window.ngii_wmts.map("map1", { 
                zoom: 7,
                maxZoom: 9,
                minZoom: 4,
                center: center,
            });
            setCurrentMap(map);

            // 줌 제한 설정
            const view = map._getMap().getView();
            view.setMaxZoom(9);
            view.setMinZoom(4);
            view.setConstrainResolution(true);

            // 마커 추가
            const marker = new window.ol.Feature({
                geometry: new window.ol.geom.Point(center)
            });

            // 마커 스타일 설정
            const markerStyle = new window.ol.style.Style({
                image: new window.ol.style.Icon({
                    src: 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path fill="blue" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>',
                    scale: 1,
                    anchor: [0.5, 1],
                })
            });

            marker.setStyle(markerStyle);

            // 마커를 담을 레이어 생성
            const vectorLayer = new window.ol.layer.Vector({
                source: new window.ol.source.Vector({
                    features: [marker]
                }),
                zIndex: 1000
            });

            // 맵에 레이어 추가
            map._getMap().addLayer(vectorLayer);

            // 라벨을 위한 HTML 요소 생성
            const labelElement = document.createElement('span');
            labelElement.className = 'map-label';
            labelElement.innerHTML = '핀테크';
            labelElement.style.cssText = `
                background-color: white;
                color: black;
                padding: 3px 7px;
                border-radius: 8px;
                font-size: 12px;
                border: 1px solid gray;
                position: absolute;
                display: inline-block;
                white-space: nowrap;
                transform: translate(-50%, -100%);
                margin-top: 5px;
                text-align: center;
                // min-width: 60px;
            `;

            // Overlay 생성
            const labelOverlay = new window.ol.Overlay({
                element: labelElement,
                position: center,
                positioning: 'bottom-center',
                offset: [0, -40]
            });

            // 맵에 Overlay 추가
            map._getMap().addOverlay(labelOverlay);


         

            // 초기화 완료 셋
            mapInitialized.current = true;
        } catch (error) {
            console.log('error',error)
        }
    }, [currentMap]);

    useEffect(() => {

        var IDX = undefined

        const moveSlider = (n) => {
            const w = 80
            let scrollLeft = $(".his-el").scrollLeft()
            scrollLeft += (w * n)
            $(".his-el").stop().animate({
                scrollLeft: scrollLeft
            }, 100, "linear")
        }

        // if (!isMobile()) {
        //     $(".his-el .ele .box ul").mCustomScrollbar({
        //         theme: "dark"
        //     });
        // } 

        // if (isMobileAndTablet()) {
        //     $(".his-arw").css("display", "none")
        // }

        $(".his-arw > div").on("mousedown", e => {
            const children = e.target.parentElement.children
            children.forEach((item, idx) => {
                if (e.target === item) {
                    IDX = idx
                }
            })
        })

        $(".his-arw > div").on("mouseup mouseleave", e => {
            IDX = undefined
            $(".his-el").stop()
        })

        setInterval(() => {
            if (IDX === 0) {
                moveSlider(-1)
            } else if (IDX === 1) {
                moveSlider(1)
            }
        }, 100)

    }, []);



    return (
        <>
            <div className="body intro">
                <main>

                    <section className="tpi bg_01">
                        <div className="wrp flx-center">
                            <div className="msg">
                                <div className="tit">핀테크 소개</div>
                                <div className="mit">대한민국 최고의 마이데이터 솔루션 서비스 기업, (주)핀테크</div>
                            </div>
                        </div>
                    </section>

                    <section className="com-his" id="history">
                        <div className="s_tit">
                            <span>연혁</span>
                        </div>
                        <div className="wrp w192">
                            <div className="his-el nscr">
                                {
                                    historyData &&
                                    historyData.map((item, index) => {
                                        return (
                                            <div className={index === 0 ? "ele now" : "ele"} key={index}>
                                                <div className="year">{item.title}</div>
                                                <div className="box" dangerouslySetInnerHTML={{ __html: item.content }}>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div className="his-arw">
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                    </section>

                    <section className="map" id="location" style={{ backgroundColor: "white" }}>
                        <div className="s_tit">
                            <span>오시는 길</span>
                        </div>


                        <div className="root_daum_roughmap root_daum_roughmap_landing">
                            <div id="map1" style={{ width: "0px", height: "0px" }}>
                            
                                <span className='material-symbols-outlined' style={{color:'#000',fontSize:'16px',padding:'10px',position:'absolute',top:'10px',left:'10px'}}>location_on</span>
                                <span style={{color:'#000',fontSize:'16px',padding:'10px',position:'absolute',top:'10px',left:'10px'}}>핀테크</span>
                                
                            </div>
                        
                        </div>

                        <div className="wrp lci">
                            <ul>
                                <li className="adrs">주소</li>
                                <li>07251 서울특별시 영등포구 영신로 166, 9층(영등포동6가, 영등포 반도아이비밸리)</li>
                            </ul>

                            <ul>
                                <li className="phone">전화</li>
                                <li>Tel : 02-6956-4148</li>
                            </ul>

                            <ul>
                                <li className="email">메일</li>
                                <li>contact@fintech1.co.kr</li>
                            </ul>
                        </div>
                    </section>
                </main>
            </div>

        </>

    );

};

export default Introduction;